import React, { useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import addIcon from "../../assets/img/icon/addIcon.png";
import sendIcon from "../../assets/img/icon/sendIcon.png";
import convertIcon from "../../assets/img/icon/convertIcon.png";
import withdrawIcon from "../../assets/img/icon/withdrawIcon.png";
import requestIcon from "../../assets/img/icon/requestIcon.png";
import payIcon from "../../assets/img/icon/payIcon.png";
import dashboardAd from "../../assets/img/dashoard_ads.gif";
import FilterIcon from "../../assets/img/icon/filter.svg";
import MapSuccess from "../../assets/img/icon/map-success.svg"
import MapPending from "../../assets/img/icon/map-pending.svg"
import SwapImg from "../../assets/img/icon/coins-swap.svg"
import { CiSearch } from "react-icons/ci";
import Kyc from '../ToDoActions/Kyc';
import PhoneNumberVerify from '../ToDoActions/PhoneNumberVerify';
import CreatePin from '../ToDoActions/CreatePin';
import AddUsername from '../ToDoActions/AddUsername';
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import FundWallet from '../ToDoActions/fundWallet';
import BalanceCard from '../BalanceCard/BalanceCard';
import { MdOutlineContentCopy } from 'react-icons/md';
import { fetchTransactions, getFormattedAmount, getTransactions } from '../../actions/payments';
import { BsSendArrowUp, BsSendArrowDown } from "react-icons/bs";
import { BsPlusCircle } from "react-icons/bs";
import { FiArrowDownLeft, FiArrowUpRight } from "react-icons/fi";
import { BiSolidBank } from "react-icons/bi";
import { MdOutlineReceiptLong } from "react-icons/md";
import { SiConvertio } from 'react-icons/si';
import LoadingScreen from '../Loading/Loading';
import { stopLoading } from '../../redux/slices/loadingSlice';
import USER_API from '../../api/user';
import { getUserWorkExperience, refreshUserDetails } from '../../actions/user';
import { getUserLocation } from '../../utils/location';
import { get } from 'jquery';
import ReactFlagsSelect from 'react-flags-select';
import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";
import UserWorkUpdate from '../ToDoActions/UserWorkUpdate.js';
import ExchangeBillboard from './ExchangeBillboard.js';
import AccountSetup from '../ToDoActions/AccountSetup.js';

const typeBadgeClasses = {
    credit: "badge-success",
    debit: "badge-danger",
    pending: "badge-swapping",
};

const typeIcons = {
  topup: <BsPlusCircle className="icon" size={20} />,
  transfer_in: <FiArrowDownLeft className="icon" size={20} />,
  transfer_out: <FiArrowUpRight className="icon" size={20} />,
  withdrawal: <BiSolidBank className="icon" size={20} />,
  fee: <MdOutlineReceiptLong className="icon" size={20} />,
};
const typeNames = {
  topup: "Topup",
  transfer_in: "Transfer In",
  transfer_out: "Transfer Out",
  withdrawal: "Withdrawal",
  fee: "Fee",
};
const txnTypes = {
  credit: "Credit",
  debit: "Debit",
};

const typeImages = {
    credit: <img src={MapSuccess} alt="Credit" className="icon" />,
    debit: <img src={MapPending} alt="Debit" className="icon" />,
    swap: <img src={SwapImg} alt="Swap" className="icon" />,
};

// Register the locale
countries.registerLocale(enLocale);

// Generate a mapping of country codes to their full names
const countryNames = countries.getNames("en", { select: "official" });

const Dashboard = () => {
    const { exchangeRates, allowedCountries, conversionRates, currencyOptions } = useSelector((state) => state.country);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [selected, setSelected] = useState("NG");
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    // const dashboardDetails = JSON.parse(localStorage.getItem('dashboardDetails'));

    const [workUpdate, setWorkUpdate] = useState();

    const baseProgress = 40;
    const kycProgress = userDetails?.kyc_profile ? 10 : 0;
    const usernameProgress = userDetails?.username ? 10 : 0;
    const phoneProgress = userDetails?.phone_verified_at ? 10 : 0;
    const transferPinProgress = userDetails?.transaction_pin ? 10 : 0;
    const fundedProgress = userDetails?.payment_history?.length > 0 ? 10 : 0;
    const workExperienceProgress = workUpdate?.length > 0 ? 10 : 0;

    const progress = baseProgress + usernameProgress + transferPinProgress + kycProgress + phoneProgress + fundedProgress + workExperienceProgress;

    const showKyc = userDetails?.account_type == 'personal' ? 
        (!userDetails?.kyc_profile || userDetails?.kyc_profile?.status != 'approved') : 
        userDetails?.business?.kyb_status != 'approved';
    const showUsername = !userDetails?.username;
    const showTransferPin = !userDetails?.transaction_pin;
    const showPhoneNumber = !userDetails?.phone_verified_at;
    const showFunded = !userDetails?.payment_history?.length > 0;
    const showWorkExperience = !workUpdate?.length > 0;

    const [detectedLocation, setDetectedLocation] = useState(null);
    const getCurrencyInfoByCountryCode = (code) => {
        return currencyOptions?.find(c => c.countryCode === code) || {};
    };
    const locationCountryCode = userDetails?.country_code || detectedLocation?.country_code || 'NG';
    const [selectedCountry, setSelectedCountry] = useState(locationCountryCode);
    const [sendCurrency, setSendCurrency] = useState(getCurrencyInfoByCountryCode(locationCountryCode)?.currencyCode);
    const [isRatesLoading, setIsRatesLoading] = useState(true);

    useEffect(() => {
        const fetchLocation = async () => {
            try {
                const loc = await getUserLocation();
                setDetectedLocation(loc);
                if (!userDetails?.country_code) {
                    setSelectedCountry(loc.country_code || 'NG');
                    setSendCurrency(getCurrencyInfoByCountryCode(loc.country_code || 'NG')?.currencyCode);
                }
            } catch (error) {
                // console.error("Error fetching location:", error);
            }
        };
        fetchLocation();
    }, [userDetails?.country_code]);

    const [copied, setCopied] = useState(false);
    const [userTransactions, setUserTransactions] = useState(false);
    const [transactionPage, setTransactionPage] = useState(1);
    const [transactionLastPage, setTransactionLastPage] = useState(1);
    const transactionsPerPage = 7;
    const [ loading, setLoading ] = useState(false);    
    const [ pageLoading, setPageLoading ] = useState(useSelector((state) => state.loading.isLoading));    
    
    const nigerianUser = userDetails?.country && userDetails?.country.toLowerCase() == 'nigeria';
    const virtualAcctNotSet = nigerianUser && userDetails?.default_virtual_account?.provider_account_id == null;
    const showToDoItems = progress < 70 || showKyc ||showPhoneNumber || showUsername || (userDetails?.account_type != 'business' && virtualAcctNotSet);

    const customLabels = Object.fromEntries(
        currencyOptions
        .filter(option => allowedCountries.includes(option.countryCode.toUpperCase()))
        .map(option => {
            const countryName = countryNames[option.countryCode];
            return [
                option.countryCode,
                `${option.currencyCode}`
            ];
        })
    );

    const supportedCurrencyCountry = currencyOptions
        .filter(option => allowedCountries.includes(option.countryCode.toUpperCase()))
        .map(option => option.countryCode);
    
    const handleCopyAccountNumber = (value) => {
        navigator.clipboard.writeText(value);
        setCopied(true);

        setTimeout(() => {
            setCopied(false);
        }, 5000);
    };

    const showUserTransactions = async () => {
        setLoading(true);
        try {
            await refreshUserDetails(dispatch);
            setUserTransactions(userDetails?.payment_history);
        } catch (error) {
            // console.error("Error fetching transactions:", error);
        } finally {
            setLoading(false);
        }
    };

    // useEffect(() => {
    //     showUserTransactions();
    // }, []);

    useEffect(() => {
        const fetchWorkExperience = async () => {
            try {
                const response = await getUserWorkExperience();
                setWorkUpdate(response?.data?.work_experiences?.data || []);
            } catch (error) {
                // console.error("Error fetching work experience:", error);
            }
        };

        fetchWorkExperience();
    }, []);
    
    const getUserTransactions = async (pageNumber = 1) => {
        try {
            setLoading(true);
            const response = await fetchTransactions(transactionsPerPage, pageNumber);
            const transactionResults = response.data.transactions;
            setUserTransactions(transactionResults.data || []);
            setTransactionLastPage(transactionResults.last_page || 1);
        } catch (error) {
            // console.error("Error fetching transactions:", error);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        getUserTransactions(transactionPage);
    }, [transactionPage]);

    const goToTransactionDetails = (refId, transaction) => {
        navigate(`/user/transactions/${refId}`, { state: { transactionDetails: transaction } });
    }

    const findRate = (from, to) => {
        if (from === to) return 1;

        const fromData = conversionRates.find(r => r.currency_code === from);
        const toData = conversionRates.find(r => r.currency_code === to);

        if (!fromData || !toData) return 0;

        const fromBuyRate = parseFloat(fromData.buy_rate);
        const toSellRate = parseFloat(toData.sell_rate);

        return parseFloat((toSellRate / fromBuyRate).toFixed(3));
    };

    const fromCurrency = sendCurrency;
    
    useEffect(() => {
      if (!selectedCountry) return;
    
      let derived = getCurrencyInfoByCountryCode(selectedCountry)?.currencyCode || null;
    
      if (!derived && Array.isArray(conversionRates) && conversionRates.length) {
        const match = conversionRates.find(
          r => (r.country_code || "").toUpperCase() === selectedCountry.toUpperCase()
        );
        if (match?.currency_code) derived = match.currency_code;
      }
    
      if (!derived && Array.isArray(conversionRates) && conversionRates.length) {
        derived = conversionRates[0].currency_code;
      }
    
      if (derived && derived !== sendCurrency) {
        setSendCurrency(derived);
      }

    }, [selectedCountry, currencyOptions, conversionRates]);

    useEffect(() => {
        const ready = Array.isArray(conversionRates) && conversionRates.length > 0 && !!sendCurrency;
        setIsRatesLoading(!ready);
    }, [conversionRates, sendCurrency]);

    const otherConversionRows = useMemo(() => {
        if (!conversionRates?.length || !fromCurrency) return [];
        return conversionRates
            .filter(r => r.currency_code !== fromCurrency)
            .map(r => ({
            ...r,
            exch: findRate(fromCurrency, r.currency_code),
        }));
    }, [conversionRates, fromCurrency]);


    const handleCountrySelect = (countryCode) => {
        setSelectedCountry(countryCode);
        setSendCurrency(getCurrencyInfoByCountryCode(countryCode)?.currencyCode);
    }

    const getGreeting = () => {
        const hour = new Date().getHours();
      
        if (hour < 12) return `Good Morning 🌞`;
        if (hour < 18) return "Good Afternoon ☀️";
        return "Good Evening 🌙";
    };


    useEffect(() => {
        if (pageLoading) {
            const timer = setTimeout(() => {
                setPageLoading(false);
                dispatch(stopLoading());
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [pageLoading, dispatch]);

    function formatTo3Decimals(value) {
        return parseFloat(value).toFixed(3);
    }
  
  return (
    <>
        {/* {pageLoading && <LoadingScreen />} */}
        <section className='dashboard'>
            <div className="container-fluid">
                {/* <section className="d-flex justify-content-between flex-wrap gap-2 align-items-center mt-2">
                    <div className="user-info">
                        <div className="d-flex align-items-center gap-1">
                            <p className="mb-0">{getGreeting()}</p>
                            <h6 className='mb-0'>{userDetails?.last_name}!</h6>
                        </div>
                    </div>
                    <div className='position-relative d-flex gap-3'>
                        <div className='text-start text-md-end'>
                            <h6 className='mb-0'>Account Number</h6>
                            <p className='text-secondary'>{userDetails?.bank_account[0]?.account_number}</p>
                        </div>
                        <div className="copy-icon">
                            <div className="position-relative" style={{ zIndex: 2 }}>
                                <MdOutlineContentCopy role="button" size={20} color="#0A95FF" onClick={handleCopyAccountNumber} />
                                {copied && (
                                    <div className="copy-tooltip text-white p-2 rounded small">
                                        Copied!
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section> */}

                {['pending', 'processing', 'in_review'].includes(userDetails?.kyc_status?.toLowerCase()) && (
                    <div className="alert alert-warning border-0 rounded-4 mb-4" role="alert" style={{ background: '#FFF9E6', color: '#856404' }}>
                        <div className="d-flex align-items-center">
                            <span className="me-3 fs-4">⏳</span>
                            <div>
                                <h6 className="mb-1 fw-bold">Verification in Progress</h6>
                                <p className="mb-0 small">Your KYC/KYB documents have been received and are currently being processed. We will notify you once the verification is complete.</p>
                            </div>
                        </div>
                    </div>
                )}

                <section className="row mb-5">
                    <div className="col-lg-12 hero_section position-relative">
                        <BalanceCard />
                    </div>
                </section>

                {showToDoItems && <div className="toDoList-section container overflow-auto my-5">
                    <div className="toDoList-header d-flex justify-content-between align-items-center gap-2">
                        <div className="d-flex flex-column">
                            <h4 className="mb-0">Complete Account Setup</h4>
                            <p className="">Finish setting up your account</p>
                        </div>

                        <div className="toDoList-progressBar" style={{ width: 78, height: 78 }}>
                            <CircularProgressbar
                                value={progress}
                                text={`${progress}%`}
                                strokeWidth={12}
                                styles={buildStyles({
                                    pathColor: progress === 100 ? "#46BA3C" : "#0A95FF",
                                    trailColor: "#E7E8EC",
                                    textColor: "#000",
                                    textSize: "16px",
                                    strokeLinecap: "butt",
                                    textStyle: { fontFamily: "'Inter', sans-serif", fontWeight: "bold" },
                                })}
                            />
                        </div>
                    </div>

                    <div className="toDoList-container overflow-auto mt-4">
                        {/* <div className="d-flex align-items-center gap-3"> */}
                        <div className="d-flex flex-column">
                            {showPhoneNumber && <PhoneNumberVerify userDetails={userDetails} />}
                            {showKyc && <Kyc userDetails={userDetails} />}
                            {virtualAcctNotSet && userDetails?.account_type != 'business' && <AccountSetup userDetails={userDetails} />}
                            {progress >= 60 && showUsername && <AddUsername userDetails={userDetails} />}
                            {/* {showWorkExperience && <UserWorkUpdate userDetails={userDetails} />} */}
                        </div>
                    </div>
                </div>}

                <section className='row'>
                    <div className="col-lg-12">
                        <div className='card wrapper__card__action'>
                            <div className='wrapper__card__action__header mb-3'>
                                <h2>Quick Actions</h2>
                            </div>
                            <div className='wrapper__card__action__content ps-0 ps-md-0'>
                                <Link to='/user/add_money' className='wrapper__card__action__content__item__link'>
                                    <div className='wrapper__card__action__content__item'>
                                        <div className="action__icon__bg">
                                            <img src={addIcon} alt="coin" className='icon'  width='16px' height="16px"/>
                                        </div>
                                        <h4>Add Money</h4>
                                    </div>
                                </Link>
                                <Link to='/user/send_money' className='wrapper__card__action__content__item__link'>
                                    <div className='wrapper__card__action__content__item'>
                                        <div className="action__icon__bg">
                                            <img src={sendIcon} alt="coin" className='icon'  width='16px' height="16px"/>
                                        </div>
                                        <h4>Send Money</h4>
                                    </div>
                                </Link>
                                <Link to='/user/converter' className='wrapper__card__action__content__item__link'>
                                    <div className='wrapper__card__action__content__item'>
                                        <div className="action__icon__bg">
                                            <img src={convertIcon} alt="coin" className='icon'  width='16px' height="16px"/>
                                        </div>
                                        <h4>Convert Funds</h4>
                                    </div>
                                </Link>
                                <Link to='/user/cards' className='wrapper__card__action__content__item__link'>
                                    <div className='wrapper__card__action__content__item'>
                                        <div className="action__icon__bg">
                                            <img src={withdrawIcon} alt="coin" className='icon'  width='16px' height="16px"/>
                                        </div>
                                        <h4>Virtual Card</h4>
                                    </div>
                                </Link>
                                <Link to='/user/request_money' className='wrapper__card__action__content__item__link'>
                                    <div className='wrapper__card__action__content__item'>
                                        <div className="action__icon__bg">
                                            <img src={requestIcon} alt="coin" className='icon'  width='16px' height="16px"/>
                                        </div>
                                        <h4>Request Money</h4>
                                    </div>
                                </Link>
                                <Link to='/user/payment_links' className='wrapper__card__action__content__item__link'>
                                    <div className='wrapper__card__action__content__item'>
                                        <div className="action__icon__bg">
                                            <img src={payIcon} alt="coin" className='icon'  width='16px' height="16px"/>
                                        </div>
                                        <h4>Pay Bills</h4>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

                {/* <div className="toDoList-section container overflow-auto my-5">
                    <div className="toDoList-header d-flex justify-content-between align-items-center gap-2">
                        <div className="d-flex flex-column">
                            <h4 className="mb-0">Complete Account Setup</h4>
                            <p className="">Finish setting up your account</p>
                        </div>

                        <div className="toDoList-progressBar" style={{ width: 78, height: 78 }}>
                            <CircularProgressbar
                                value={progress}
                                text={`${progress}%`}
                                strokeWidth={12}
                                styles={buildStyles({
                                    pathColor: progress === 100 ? "#46BA3C" : "#0A95FF",
                                    trailColor: "#E7E8EC",
                                    textColor: "#000",
                                    textSize: "16px",
                                    strokeLinecap: "butt",
                                    textStyle: { fontFamily: "'Inter', sans-serif", fontWeight: "bold" },
                                })}
                            />
                        </div>
                    </div>

                    <div className="toDoList-container overflow-auto mt-4">
                        {/* <div className="d-flex align-items-center gap-3"> */}
                        {/* <div className="d-flex flex-column">
                            {showKyc && <Kyc userDetails={userDetails} />}
                            {showPhoneNumber && <PhoneNumberVerify userDetails={userDetails} />}
                            {showFunded && <FundWallet userDetails={userDetails} />}
                            {showTransferPin && <CreatePin userDetails={userDetails} />}
                            {showUsername && <AddUsername userDetails={userDetails} />}
                            {showWorkExperience && <UserWorkUpdate userDetails={userDetails} />}
                        </div>
                    </div> */}
                {/* </div> */}

                {/* {userTransactions?.data?.length > 0 ? ( */}
                {userTransactions?.length > 0 ? (
                    <section className="table__tnx-section row my-5">
                        <div className='col-md-6 col-sm-12 my-5'>
                            <div className='currency__card py-1'>
                                <div className='d-flex justify-content-between align-items-center gap-2 p-3 py-4'>
                                    <div className='transaction__table__header'>Recent Transactions</div>
                                    <div>
                                        <Link to="/user/transactions" className="filter__button">
                                            {/* <img src={FilterIcon} alt="" /> */}
                                            See All
                                        </Link>
                                    </div>
                                </div>
                                {loading ? (
                                    <div className="text-center my-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="dash-txn-list">
                                        {userTransactions?.map((transaction) => {
                                            const txnIsFee = ['fee', 'statutory_fee'].includes(transaction.purpose);
                                            const status = txnIsFee && transaction.status == 'outstanding' ? 'completed' : transaction.status;
                                            const purpose = (transaction.purpose == 'statutory_fee' && transaction.metadata?.statutory_fee_label) ? transaction.metadata?.statutory_fee_label : transaction.purpose; 
                                            return (
                                            <div
                                                key={transaction.id}
                                                className="dash-txn-item"
                                                onClick={() => goToTransactionDetails(transaction.id, transaction)}
                                            >
                                                <div className="dash-txn-left">
                                                    <div className={`dash-txn-icon ${transaction.type}`}>
                                                        {typeIcons[purpose] || (transaction.type === 'credit' ? <FiArrowDownLeft size={18} /> : <FiArrowUpRight size={18} />)}
                                                    </div>
                                                    <div className="dash-txn-info">
                                                        <h4>
                                                            {/* {purpose?.replace(/_/g, ' ') || txnTypes[transaction.type]} */}
                                                            {transaction.purpose_of_transaction}
                                                        </h4>
                                                        <span>
                                                            {transaction.created_at && new Date(transaction.created_at).toLocaleString("default", { day: "numeric", month: "short", year: "numeric" })}
                                                            {' · '}
                                                            {transaction.created_at && new Date(transaction.created_at).toLocaleTimeString("default", { hour: "2-digit", minute: "2-digit", hour12: true })}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="dash-txn-right">
                                                    <div className={`dash-txn-amount ${transaction.type}`}>
                                                        {transaction.type === 'credit' ? '+' : transaction.type === 'debit' ? '-' : ''}
                                                        {transaction.wallet?.currency_symbol || transaction.wallet?.currency_code}
                                                        {getFormattedAmount(transaction.amount)}
                                                    </div>
                                                    <span className={`dash-txn-status ${status}`}>{status}</span>
                                                </div>
                                            </div>
                                        )})}

                                        {transactionLastPage > 1 && (
                                            <div className="dash-txn-pagination" aria-label="Recent transactions pagination">
                                                <button
                                                    type="button"
                                                    onClick={() => setTransactionPage((page) => Math.max(1, page - 1))}
                                                    disabled={transactionPage === 1 || loading}
                                                    aria-label="Previous transactions page"
                                                >
                                                    ‹
                                                </button>
                                                <span>Page {transactionPage} of {transactionLastPage}</span>
                                                <button
                                                    type="button"
                                                    onClick={() => setTransactionPage((page) => Math.min(transactionLastPage, page + 1))}
                                                    disabled={transactionPage === transactionLastPage || loading}
                                                    aria-label="Next transactions page"
                                                >
                                                    ›
                                                </button>
                                            </div>
                                        )}

                                                {/* {userTransactions?.data?.map((transaction) => (
                                                    <tr key={transaction.ref_id} onClick={() => goToTransactionDetails(transaction.ref_id, transaction)} role='button'>
                                                        <td>
                                                            <div className="row align-items-start ">
                                                                <div className="col-8 d-flex align-items-start gap-4">
                                                                    <span className={`badge ${typeBadgeClasses[transaction.status]}`}>
                                                                        {typeImages[transaction.type]}
                                                                    </span>
                                                                    <div className='txn__details'>
                                                                        <h3 className='mb-0 text-capitalize'>{transaction.type}</h3>
                                                                        <p className='date mb-0'>{transaction.created_at && new Date(transaction.created_at * 1000).toLocaleString("default", { day: "numeric", month: "short", year: "numeric",})}</p>
                                                                        <span className='date'>{transaction.created_at && new Date(transaction.created_at * 1000).toLocaleTimeString("default", { hour: "2-digit", minute: "2-digit", hour12: true })}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className='col-4 status'>
                                                            <div className={`rounded ${transaction.status === 'success' ? 'status__success' : transaction.status === 'failed' ? 'status__failed' : 'status__pending'}`}>
                                                                <span className='text-capitalize'>{transaction.status}</span>
                                                            </div>
                                                        </td>
                                                        <td className='col-4 amount'>
                                                            <div className={`font-medium d-flex gap-1 justify-content-end align-items-start ${transaction.status === 'success' ? 'text-green-500' : transaction.status === 'failed' ? 'text-red-500' : 'text-swap'}`}>
                                                                <span className=''>{transaction.type === 'credit' ? '+' : transaction.type === 'debit' ? '-' : ''}</span> 
                                                                <span className=''>{transaction.amount}</span>
                                                                <span className=''>{transaction.currency}</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))} */}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className='col-md-6 col-sm-12 my-5'>
                            <div className='currency__card py-1'>
                                <ExchangeBillboard />
                            </div>
                            <div className="row my-5">
                                <div className="col-12 d-flex justify-content-center">
                                    <img src={dashboardAd} alt="" className="img-fluid rounded-4 w-100" />
                                </div>
                            </div>
                        </div>
                    </section>
                ) : (
                    <section className="new__user-section my-5">
                        <div className="ads__container my-5">
                            <div className="ads__container-details">
                                <h3>Convert your local currency to any other African currency!</h3>
                                <p>Exchange your local currency in-app, then feel free to transact with it however you please - with great exchange rates and low fees </p>
                            </div>
                        </div>
                        <div className="no_tnx__display row">
                            <div className="col-md-6 col-sm-12 my-3">
                            <div className='currency__card py-1'>
                                <div className='d-flex justify-content-between align-items-center gap-2 p-3 py-4'>
                                    <div className='transaction__table__header'>Recent Transactions</div>
                                    <div>
                                        <button className="filter__button">
                                            {/* <img src={FilterIcon} alt="" /> */}
                                            See All
                                        </button>
                                    </div>
                                </div>
                                <div className="text-center p-2 my-5 py-5">
                                    <h3>No transaction yet</h3>
                                    <p>All transactions made will appear here</p>
                                </div>
                            </div>
                            </div>
                            <div className="col-md-6 col-sm-12 my-3">
                                <div className='currency__card'>
                                    <ExchangeBillboard />
                                </div>
                                <div className='pt-5 d-flex justify-content-center'>
                                    <img src={dashboardAd} alt="" className="img-fluid rounded-4 w-100" />
                                </div>
                            </div>
                        </div>
                    </section>
                )}
            </div>
        </section>
    </>
  )
}

export default Dashboard
